import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { getDeviceId } from "../pages/document/util";
import { store } from "../store/store";
import { parseStringifiedJson } from "./util";

const vosClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_VOS_API_URL, // hoặc URL cứng
  timeout: 10000, // 10s
  headers: {
    "Content-Type": "application/json",
  },
});

// ===== Request Interceptor =====
vosClient.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const token = store.getState().user?.current?.accessToken;
    const deviceId = await getDeviceId();

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.headers) {
      config.headers.X_DEVICE_UDID = deviceId || "00000000-0000-0000-0000-000000000000";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// ===== Response Interceptor =====
vosClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return {
      ...response,
      data: response.data
        ? {
            ...response.data,
            Data: parseStringifiedJson(response.data?.Data),
          }
        : response.data,
    }; // trả về data luôn cho gọn
  },
  (error) => {
    if (error.response) {
      // Xử lý lỗi server trả về
      console.error("API Error:", error.response.data);

      // Ví dụ: token hết hạn
      if (error.response.status === 401) {
        // logout / refresh token
      }
    } else {
      // Lỗi không có response (mạng, timeout)
      console.error("Network Error:", error);
    }

    return Promise.reject(error?.response?.data || error);
  },
);

export default vosClient;

export interface IVosResponse<T> {
  StatusCode: number;
  Message: string;
  TotalRecord: number;
  Data: T;
}
